export default __webpack_public_path__ + "static/media/Twitter-02.86c381b2.svg";